import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Stack, Box, Tabs, Button, Tab, MenuItem, Badge } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { onValue, ref } from "firebase/database";
import { db } from "../../firebase";
import { getOrders } from "../../services/orders";
import { useTheme, useMediaQuery } from '@mui/material';
import OrderListTable from "./OrdersListTable";
import NoOrders from "./NoOrders";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import LoadingCard from "../Loading";
import StyledPopup from "../StyledMenu";

const Orders = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const navigate = useNavigate()
  const { currentBranch } = useSelector((state) => state.branch);
  const [isLoading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState("all");
  const [orders, setOrders] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const branchId = currentBranch.id || {};
  const handleChange = (__, newCurrentTab) => {
    setCurrentTab(newCurrentTab);
  };

  const handleGetData = () => {
    getOrders(branchId).then((r) => {
      setLoading(false);
      setOrders(r.data.data);
    });
  };
  console.log('my orders', orders);
  const updateData = () => {
    const dbRef = ref(db, `orders/${branchId}`);
    return onValue(dbRef, (snapshot) => {
      if (snapshot.exists()) {
        handleGetData()
      }
    });
  };

  useEffect(() => {
    handleGetData();
    updateData()
  }, []);

  const pendingOrders = orders?.filter((i) => i.order_status === "PENDING");
  const confirmedOrders = orders?.filter((i) => i.order_status === "Confirmed");
  const readyOrders = orders?.filter((i) => i.order_status === "Ready");
  const completeOrders = orders?.filter((i) => i.order_status === "Completed");

  const filterOptions = [
    { name: "All Orders", onClick: () => setCurrentTab("all") },
    { name: "Pending", onClick: () => setCurrentTab("pending") },
    { name: "Preparing", onClick: () => setCurrentTab("confirmed") },
    { name: "Ready", onClick: () => setCurrentTab("ready") },
    { name: "Completed", onClick: () => setCurrentTab("completed") }
  ];

  return (
    <Stack>
      {isLoading && <LoadingCard />}
      {!isLoading && orders?.length == 0 && <NoOrders />}
      {!isLoading && orders?.length > 0 && (
        <>
          {
            isLargeScreen &&
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ borderBottom: 1, borderColor: "divider", mt: 4, mb: 2 }}
            >
              <Box>
                <Tabs value={currentTab} onChange={handleChange}>
                  <Tab value={"all"} label="All Orders" />
                  <Tab value={"pending"} label="Pending" />
                  <Tab value={"confirmed"} label="Preparing" />
                  <Tab value={"ready"} label="Ready" />
                  <Tab value={"completed"} label="Completed" />
                </Tabs>
              </Box>

              <Box>
                <Button
                  variant="contained"
                  disableElevation
                  startIcon={<AddIcon />}
                  sx={{ color: "white" }}
                  onClick={() => navigate("/dashboard/new-order")}
                >
                  Create New Order
                </Button>
              </Box>
            </Stack>
          }

          {
            !isLargeScreen &&
            <Box sx={{ display: "flex", columnGap: 2, justifyContent: "right", mt: 2, alignItems: "center" }}>
              <Badge
                variant="dot"
                color="primary"
                invisible={currentTab === 'all'}
                onClick={(e) => setAnchorEl(e.currentTarget)}>
                <TuneIcon />
              </Badge >

              <Button
                variant="contained"
                disableElevation
                startIcon={<AddIcon />}
                sx={{ color: "white" }}
                size="small"
                onClick={() => navigate("/dashboard/new-order")}
              >
                New Order
              </Button>

              <StyledPopup open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
                {filterOptions.map(el => (
                  <MenuItem onClick={() => { el.onClick(); setAnchorEl(null) }}>{el.name}</MenuItem>
                ))}
              </StyledPopup>
            </Box>
          }

          <Stack>
            {currentTab === "all" && <OrderListTable ordersData={orders} refresh={handleGetData} />}
            {currentTab === "pending" && (
              <OrderListTable ordersData={pendingOrders} refresh={handleGetData} />
            )}
            {currentTab === "confirmed" && (
              <OrderListTable ordersData={confirmedOrders} refresh={handleGetData} />
            )}
            {currentTab === "ready" && (
              <OrderListTable ordersData={readyOrders} refresh={handleGetData} />
            )}
            {currentTab === "completed" && (
              <OrderListTable ordersData={completeOrders} refresh={handleGetData} />
            )}
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default Orders;
